export const num = (n, d = 2) => Number(n || 0).toLocaleString("es-ES", { minimumFractionDigits: d, maximumFractionDigits: d });
export const fechaEs = (iso) => (iso ? iso.split("-").reverse().join("/") : "");
export const hoy = () => new Date().toISOString().slice(0, 10);

const r2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100;
const r3 = (n) => Math.round((n + Number.EPSILON) * 1000) / 1000;

const ESTADO_EMITIDA = {
  borrador: ["Borrador", "bg-slate-100 text-slate-600 border-slate-200"],
  enviada: ["Enviada", "bg-cyan-50 text-[#007F91] border-cyan-200"],
  aprobada: ["Aprobada", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  facturada: ["Facturada", "bg-[#1B2B4B] text-white border-[#1B2B4B]"],
  rechazada: ["Rechazada", "bg-rose-50 text-rose-700 border-rose-200"],
};

export const COND_DEFECTO = { gg_pct: 0, bi_pct: 0, baja_pct: 0, iva_pct: 21, isp: false, irpf_pct: 0, retencion_pct: 5 };
const PCTS = ["gg_pct", "bi_pct", "baja_pct", "iva_pct", "irpf_pct", "retencion_pct"];

export const normCond = (cond) => {
  const c = { ...COND_DEFECTO, ...cond };
  return { ...Object.fromEntries(PCTS.map((k) => [k, Math.min(100, Math.max(0, Number(c[k]) || 0))])), isp: !!c.isp };
};

export const estadoRecibida = (c) => {
  if (c.estado === "aprobada") return c.pagada ? ["Pagada", "bg-emerald-50 text-emerald-700 border-emerald-200"] : ["Pendiente de pago", "bg-cyan-50 text-[#007F91] border-cyan-200"];
  if (c.estado === "rechazada") return ["Rechazada", "bg-rose-50 text-rose-700 border-rose-200"];
  return ["Pendiente de revisión", "bg-amber-50 text-amber-700 border-amber-200"];
};

export function Insignia({ par, testid }) {
  const [txt, cls] = par;
  return <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold ${cls}`} data-testid={testid}>{txt}</span>;
}

export const insigniaEmitida = (estado) => ESTADO_EMITIDA[estado] || ESTADO_EMITIDA.borrador;

export function calcular(p, e) {
  const modo = e?.modo || p.modo;
  const valor = e && e.valor !== undefined ? e.valor : p.valor;
  const v = Number(valor) || 0;
  const origen = r3(modo === "medicion" ? v : (p.cantidad_presupuesto * v) / 100);
  const impOri = r2(origen * p.precio);
  const impAnt = r2(p.cantidad_anterior * p.precio);
  return { ...p, modo, valor, cantidad_origen: origen, cantidad_periodo: r3(origen - p.cantidad_anterior),
    desviacion: r3(origen - p.cantidad_presupuesto), importe_origen: impOri, importe_periodo: r2(impOri - impAnt) };
}

export function totales(lineas, cond) {
  const s = (k) => r2(lineas.reduce((a, x) => a + x[k], 0));
  const cd = normCond(cond);
  const pct = (b, p) => r2((b * p) / 100);
  const ejec = s("importe_periodo");
  const gg = pct(ejec, cd.gg_pct);
  const bi = pct(ejec, cd.bi_pct);
  const base = r2(ejec + gg + bi - pct(ejec + gg + bi, cd.baja_pct));
  const iva = cd.isp ? 0 : pct(base, cd.iva_pct);
  const irpf = pct(base, cd.irpf_pct);
  const total = r2(base + iva - irpf);
  const ret = pct(base, cd.retencion_pct);
  const pres = s("importe_presupuesto");
  const origen = s("importe_origen");
  return { base_presupuesto: pres, base_origen: origen, base_anterior: s("importe_anterior"), ejecucion_periodo: ejec,
    gg_importe: gg, bi_importe: bi, baja_importe: pct(ejec + gg + bi, cd.baja_pct), base_periodo: base, iva_periodo: iva,
    irpf_periodo: irpf, total_periodo: total, retencion_importe: ret, liquido: r2(total - ret),
    pendiente_certificar: r2(pres - origen), condiciones: cd };
}
